/* global axios */
import ApiClient from './ApiClient';

class GmAnalyticsAPI extends ApiClient {
  constructor() {
    super('gm_analytics', { accountScoped: true, apiVersion: 'v1' });
  }

  getDashboard(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Dashboard URL:', `${this.url}/dashboard`);
    console.log('🔍 GmAnalyticsAPI: Base URL:', this.url);
    console.log('🔍 GmAnalyticsAPI: Account ID from route:', this.accountIdFromRoute);
    console.log('🔧 GmAnalyticsAPI: Raw filters received:', filters);
    console.log('🔧 GmAnalyticsAPI: Filters type:', typeof filters);
    console.log('🔧 GmAnalyticsAPI: Filters keys:', Object.keys(filters));
    
    const params = {};
    
    // Add date range parameters
    if (filters.dateRange) {
      console.log('🔧 GmAnalyticsAPI: Date range found:', filters.dateRange);
      console.log('🔧 GmAnalyticsAPI: Date range type:', typeof filters.dateRange);
      console.log('🔧 GmAnalyticsAPI: Date range keys:', Object.keys(filters.dateRange));
      
      if (filters.dateRange.preset) {
        params['date_range[preset]'] = filters.dateRange.preset;
        console.log('🔧 GmAnalyticsAPI: Added preset param:', filters.dateRange.preset);
      }
      if (filters.dateRange.from) {
        params['date_range[from]'] = filters.dateRange.from;
        console.log('🔧 GmAnalyticsAPI: Added from param:', filters.dateRange.from);
      }
      if (filters.dateRange.to) {
        params['date_range[to]'] = filters.dateRange.to;
        console.log('🔧 GmAnalyticsAPI: Added to param:', filters.dateRange.to);
      }
    } else {
      console.log('🔧 GmAnalyticsAPI: No date range in filters');
    }
    
    // Add channel and agent parameters
    if (filters.channel) {
      params['channel_id'] = filters.channel;
      console.log('🔧 GmAnalyticsAPI: Added channel param:', filters.channel);
    }
    if (filters.agent) {
      params['agent_id'] = filters.agent;
      console.log('🔧 GmAnalyticsAPI: Added agent param:', filters.agent);
    }
    
    // Add business hours parameter
    if (filters.business_hours !== undefined) {
      params['business_hours'] = filters.business_hours;
      console.log('🔧 GmAnalyticsAPI: Added business_hours param:', filters.business_hours);
    }
    
    console.log('🔧 GmAnalyticsAPI: Final params object:', params);
    console.log('🔧 GmAnalyticsAPI: Final params keys:', Object.keys(params));
    
    return axios.get(`${this.url}/dashboard`, { params });
  }

  getRealTimeData() {
    return axios.get(`${this.url}/real_time_data`);
  }

  getAIInsights() {
    return axios.get(`${this.url}/ai_insights`);
  }

  getConversationAnalytics(params = {}) {
    return axios.get(`${this.url}/conversation_analytics`, {
      params,
    });
  }

  getSentimentAnalytics(params = {}) {
    return axios.get(`${this.url}/sentiment_analytics`, {
      params,
    });
  }

  getSentimentTrend(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Sentiment Trend URL:', `${this.url}/sentiment_trend`);
    console.log('🔧 GmAnalyticsAPI: Sentiment Trend filters:', filters);
    
    const params = {};
    
    // Add date range parameters
    if (filters.dateRange) {
      if (filters.dateRange.preset) {
        params['date_range[preset]'] = filters.dateRange.preset;
      }
      if (filters.dateRange.from) {
        params['date_range[from]'] = filters.dateRange.from;
      }
      if (filters.dateRange.to) {
        params['date_range[to]'] = filters.dateRange.to;
      }
    }
    
    // Add channel and agent parameters
    if (filters.channel) {
      params['channel_id'] = filters.channel;
    }
    if (filters.agent) {
      params['agent_id'] = filters.agent;
    }
    
    console.log('🔧 GmAnalyticsAPI: Sentiment Trend params:', params);
    
    return axios.get(`${this.url}/sentiment_trend`, { params });
  }

  getConversationTrend(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Conversation Trend URL:', `${this.url}/conversation_trend`);
    console.log('🔧 GmAnalyticsAPI: Conversation Trend filters:', filters);
    
    const params = {};
    
    // Add date range parameters
    if (filters.dateRange) {
      if (filters.dateRange.preset) {
        params['date_range[preset]'] = filters.dateRange.preset;
      }
      if (filters.dateRange.from) {
        params['date_range[from]'] = filters.dateRange.from;
      }
      if (filters.dateRange.to) {
        params['date_range[to]'] = filters.dateRange.to;
      }
    }
    
    // Add channel and agent parameters
    if (filters.channel) {
      params['channel_id'] = filters.channel;
    }
    if (filters.agent) {
      params['agent_id'] = filters.agent;
    }
    
    console.log('🔧 GmAnalyticsAPI: Conversation Trend params:', params);
    
    return axios.get(`${this.url}/conversation_trend`, { params });
  }

  getResponseTimeTrend(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Response Time Trend URL:', `${this.url}/response_time_trend`);
    console.log('🔧 GmAnalyticsAPI: Response Time Trend filters:', filters);
    
    const params = {};
    
    // Add date range parameters
    if (filters.dateRange) {
      if (filters.dateRange.preset) {
        params['date_range[preset]'] = filters.dateRange.preset;
      }
      if (filters.dateRange.from) {
        params['date_range[from]'] = filters.dateRange.from;
      }
      if (filters.dateRange.to) {
        params['date_range[to]'] = filters.dateRange.to;
      }
    }
    
    // Add channel and agent parameters
    if (filters.channel) {
      params['channel_id'] = filters.channel;
    }
    if (filters.agent) {
      params['agent_id'] = filters.agent;
    }
    
    console.log('🔧 GmAnalyticsAPI: Response Time Trend params:', params);
    
    return axios.get(`${this.url}/response_time_trend`, { params });
  }

  getChannelPerformance(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Channel Performance URL:', `${this.url}/channel_performance`);
    console.log('🔧 GmAnalyticsAPI: Channel Performance filters:', filters);
    
    const params = {};
    
    // Add date range parameters
    if (filters.dateRange) {
      if (filters.dateRange.preset) {
        params['date_range[preset]'] = filters.dateRange.preset;
      }
      if (filters.dateRange.from) {
        params['date_range[from]'] = filters.dateRange.from;
      }
      if (filters.dateRange.to) {
        params['date_range[to]'] = filters.dateRange.to;
      }
    }
    
    // Add channel and agent parameters
    if (filters.channel) {
      params['channel_id'] = filters.channel;
    }
    if (filters.agent) {
      params['agent_id'] = filters.agent;
    }
    
    console.log('🔧 GmAnalyticsAPI: Channel Performance params:', params);
    
    return axios.get(`${this.url}/channel_performance`, { params });
  }

  getAgentPerformanceMatrix(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Agent Performance Matrix URL:', `${this.url}/agent_performance_matrix`);
    console.log('🔧 GmAnalyticsAPI: Agent Performance Matrix filters:', filters);
    
    const params = {};
    
    // Add date range parameters (using since/until format for reports)
    if (filters.from) {
      params['since'] = filters.from;
    }
    if (filters.to) {
      params['until'] = filters.to;
    }
    if (filters.businessHours !== undefined) {
      params['business_hours'] = filters.businessHours;
    }
    if (filters.channelId) {
      params['channel_id'] = filters.channelId;
    }
    if (filters.agentId) {
      params['agent_id'] = filters.agentId;
    }
    
    console.log('🔧 GmAnalyticsAPI: Agent Performance Matrix params:', params);
    
    return axios.get(`${this.url}/agent_performance_matrix`, { params });
  }

  getEnhancedAgentMetrics(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Enhanced Agent Metrics URL:', `${this.url}/enhanced_agent_metrics`);
    console.log('🔧 GmAnalyticsAPI: Enhanced Agent Metrics filters:', filters);
    
    const params = {};
    
    // Add date range parameters (using date_range format like dashboard)
    if (filters.dateRange) {
      params['date_range'] = filters.dateRange;
    }
    if (filters.period) {
      params['period'] = filters.period;
    }
    if (filters.businessHours !== undefined) {
      params['business_hours'] = filters.businessHours;
    }
    if (filters.channelId) {
      params['channel_id'] = filters.channelId;
    }
    if (filters.agentId) {
      params['agent_id'] = filters.agentId;
    }
    
    console.log('🔧 GmAnalyticsAPI: Enhanced Agent Metrics params:', params);
    
    return axios.get(`${this.url}/enhanced_agent_metrics`, { params });
  }

  getAgentPerformanceTrends(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Agent Performance Trends URL:', `${this.url}/agent_performance_trends`);
    console.log('🔧 GmAnalyticsAPI: Agent Performance Trends filters:', filters);
    
    const params = {};
    
    // Add date range parameters (using since/until format for reports) - SAME AS WORKING AGENT PERFORMANCE MATRIX
    if (filters.from) {
      params['since'] = filters.from;
    }
    if (filters.to) {
      params['until'] = filters.to;
    }
    if (filters.businessHours !== undefined) {
      params['business_hours'] = filters.businessHours;
    }
    
    console.log('🔧 GmAnalyticsAPI: Agent Performance Trends params:', params);
    
    return axios.get(`${this.url}/agent_performance_trends`, { params });
  }

  getPerformanceAnalytics(params = {}) {
    return axios.get(`${this.url}/performance_analytics`, {
      params,
    });
  }

  getPredictiveAnalytics(params = {}) {
    return axios.get(`${this.url}/predictive_analytics`, {
      params,
    });
  }

  getRevenueAnalytics(params = {}) {
    return axios.get(`${this.url}/revenue_analytics`, {
      params,
    });
  }

  getComplianceAnalytics(params = {}) {
    return axios.get(`${this.url}/compliance_analytics`, {
      params,
    });
  }

  getCustomerExperienceAnalytics(params = {}) {
    return axios.get(`${this.url}/customer_experience_analytics`, {
      params,
    });
  }

  getOperationalAnalytics(params = {}) {
    return axios.get(`${this.url}/operational_analytics`, {
      params,
    });
  }

  exportConversations(filters = {}) {
    console.log('🔍 GmAnalyticsAPI: Export conversations with filters:', filters);
    
    const params = {};
    
    // Add date range parameters (matching native Chatwoot reports format)
    if (filters.from) {
      params['since'] = filters.from;
    }
    if (filters.to) {
      params['until'] = filters.to;
    }
    
    // Add business hours parameter
    if (filters.businessHours !== undefined) {
      params['business_hours'] = filters.businessHours;
    }
    
    // Add channel and agent parameters
    if (filters.channelId) {
      params['channel_id'] = filters.channelId;
    }
    if (filters.agentId) {
      params['agent_id'] = filters.agentId;
    }
    
    console.log('🔧 GmAnalyticsAPI: Export params:', params);
    
    return axios.get(`${this.url}/export_conversations`, {
      params
    });
  }

  getExportRequests() {
    return axios.get(`${this.url}/export_requests`);
  }

  downloadExport(exportId) {
    return axios.get(`${this.url}/download_export/${exportId}`, {
      responseType: 'blob'
    });
  }

  deleteExportRequest(exportId) {
    return axios.delete(`${this.url}/export_requests/${exportId}`);
  }
}

export default new GmAnalyticsAPI();
